<mat-card>
<div class="details-view-container" *ngIf="licenseObject" fxLayout="column" fxLayoutGap="15px" >

    <div fxLayout="row" fxLayoutGap="15px" class="button-container">
        <button [disabled]="!(userPermissions | async).license.write" (click)="modify()" mat-stroked-button color="primary">
            <mat-icon>create</mat-icon> <span> Edytuj</span>
        </button>
        <button [disabled]="!(userPermissions | async).license.admin_root" (click)="delete()" mat-stroked-button color="warn">
            <mat-icon>delete</mat-icon> <span> Usuń</span>
        </button>
    </div>
  <mat-card>


        <div fxFlex="100">
            <div fxLayout="row">
              <h3>Dane licencji</h3>
            </div>

            <div fxLayout="row">
                <app-detail fxFlex="50" header="Rodzaj licencji" [value]="licenseObject.typeOfLicense?.name"></app-detail>
                <app-detail fxFlex="50" header="Numer licencji" [value]="licenseObject?.licenseNumber"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="50" header="Urządzenie" [value]="licenseObject?.device?.name"
                          [link]="licenseObject.device ? ['/urzadzenia/szczegoly/', licenseObject?.device.uuid] : undefined">
              </app-detail>

                <app-detail header="Data ważności do"
                            [value]="licenseObject.expirationDate | date:'y-MM-dd'"></app-detail>
            </div>

            <div fxLayout="row">
              <app-detail fxFlex="50" header="Notatka" [value]="licenseObject?.note"></app-detail>

              <app-detail fxFlex="50" header="Użytkownik"
                          [value]="licenseObject?.user?.firstName + ' ' + licenseObject?.user?.lastName"
                          [link]="licenseObject.user ? ['/urzadzenia/uzytkownicy/szczegoly/', licenseObject.user.uuid] : undefined">
              </app-detail>
            </div>

        </div>

  </mat-card>
</div>
</mat-card>
